// extracted by mini-css-extract-plugin
export default {"accordionContainer":"AccordionWidget_accordionContainer__90o3k","text":"AccordionWidget_text__jMftz","icon":"AccordionWidget_icon__pZVPN"};